import axios from "axios";
import Config from "../../config";

const ReportChartCustomer = params => {
    const {channel_id, start_date, end_date} = params
    return axios({
        method: "POST",
        url: (Config.url || '') + "/api/report/chart-customer",
        data: { channel_id, start_date, end_date }
    });
};

export default ReportChartCustomer;
